import 'css-chunksrc/client/scenes/logIn/styles.scss';export default {
  "logIn": "_logIn_w2nzl_1",
  "heading": "_heading_w2nzl_8",
  "title": "_title_w2nzl_12",
  "subTitle": "_subTitle_w2nzl_19",
  "form": "_form_w2nzl_25",
  "group": "_group_w2nzl_29",
  "label": "_label_w2nzl_33",
  "input": "_input_w2nzl_39",
  "invalidInput": "_invalidInput_w2nzl_53",
  "button": "_button_w2nzl_57",
  "loader": "_loader_w2nzl_80",
  "loaderMain": "_loaderMain_w2nzl_94"
};